import { Typography } from '@material-ui/core'
import React from 'react'

import { useStyles } from './styles'

interface EmptyStateProps {
  description: string
  children?: React.ReactNode
  srcImage: string
}

export function EmptyState({
  srcImage,
  description,
  children,
}: EmptyStateProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <img src={srcImage} />
      <Typography variant='subtitle2'>{description}</Typography>
      {children}
    </div>
  )
}
